import { useTheme } from '@mui/material';
export var useThemeColor = function useThemeColor(color) {
  var theme = useTheme();
  return getThemeColor(theme, color);
};
export var getThemeColor = function getThemeColor(theme, color) {
  var isCommonColor = color === null || color === void 0 ? void 0 : color.startsWith('common.');
  return isCommonColor ? theme.palette.common[color.split('.')[1]] : theme.palette[color].main;
};